// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1IefD","footer":"ModalFilter_footer__3EdqM"};